module.exports = __webpack_public_path__ + "img/logo-5.e3c04c70.png";